import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=ffb2494a&scoped=true"
import script from "./VerifyAccount.vue?vue&type=script&lang=js"
export * from "./VerifyAccount.vue?vue&type=script&lang=js"
import style0 from "./VerifyAccount.vue?vue&type=style&index=0&id=ffb2494a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb2494a",
  null
  
)

export default component.exports